module.exports = __webpack_public_path__ + "img/x-logo.60fe1c71.png";